import { Controller } from "@hotwired/stimulus"

// Autocomplétion « contact » du formulaire de facture — remplace
// app/assets/javascripts/invoices.js.erb.
//
// Deux problèmes de l'ancien code disparaissent ici :
//
//  1. Il fallait déléguer sur #modal-holder (`$("#modal-holder").on('keyup',
//     '#invoice_term', …)`) parce que le formulaire arrive par innerHTML,
//     donc après le $(document).ready. Stimulus observe le document : le
//     connect() se déclenche sur le nœud injecté, la délégation devient
//     inutile — et avec elle le remontage du widget à chaque frappe.
//
//  2. La valeur envoyée à /contacts/autocomplete était lue au moment du keyup,
//     HORS du callback `source` : elle était donc figée sur la frappe
//     PRÉCÉDENTE (une lettre de retard, rien pour le premier caractère
//     déclencheur). On utilise `request.term`, la valeur courante que
//     $.ui.autocomplete passe justement en argument.
//
// jQuery UI reste le moteur : le widget est déjà dans vendor.js et fournit
// menu, navigation clavier et surbrillance (_renderItem de legacy.js).
export default class extends Controller {
  static values = { url: String, fieldId: String }

  connect() {
    this.$input = window.jQuery(this.element)

    this.$input.autocomplete({
      source: (request, response) => {
        window.jQuery.ajax({
          method: "GET",
          url: this.urlValue,
          data: { term: request.term },
          success: (data) => {
            response(
              window.jQuery.map(data, (item) => ({ label: item.label, id: item.id }))
            )
          },
          error: () => response([])
        })
      },
      autoFocus: true,
      minLength: 3,
      select: (event, ui) => {
        event.preventDefault()
        this.element.value = ui.item.label
        const target = document.getElementById(this.fieldIdValue)
        if (target) target.value = ui.item.id
      }
    })
  }

  disconnect() {
    if (this.$input && this.$input.data("ui-autocomplete")) {
      this.$input.autocomplete("destroy")
    }
  }
}
